import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PaymentBg from "../../assets/images/payment/payment.png";
import useForm from "../../hooks/useForm";
import Swal from "sweetalert2";
import axios from "axios";

const Payment = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const [invoice, setInvoice] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const navigate = useNavigate();

  const validate = async (values) => {
    const errors = {};
    if (!values.tranno) {
      errors.tranno = "Please enter your transaction ID";
      return errors;
    }

    // Trim the transaction ID to remove any spaces
    const trimmedTranNo = values.tranno.trim().toUpperCase();

    // Log the exact URL for debugging
    const requestUrl = `${API_URL}/verify-transaction/${encodeURIComponent(
      trimmedTranNo
    )}`;

    // Verify if transaction exists
    setIsVerifying(true);

    try {
      const response = await axios.get(requestUrl, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.isValid) {
        setInvoice(response.data.invoice);
        // If valid, we can proceed with the form submission
        return {};
      } else {
        errors.tranno = response.data.message || "Invalid transaction ID";
      }
    } catch (error) {
      console.error("Error verifying transaction:", error);
      errors.tranno =
        error.response?.data?.message || "Error verifying transaction ID";
    } finally {
      setIsVerifying(false);
    }

    return errors;
  };

  const { values, errors, isSubmitting, handleChange, handleSubmit } = useForm(
    {
      tranno: "",
    },
    validate
  );

  const onSubmit = async (values) => {
    try {
      Swal.fire({
        title: "Success!",
        text: "Transaction verified successfully",
        // icon: "success",
        showConfirmButton: false,
        timer: 2000,
        willClose: () => {
          // Redirect to confirmation page with transaction number
          navigate(`/payment/${values.tranno.toUpperCase()}`);
        },
      });
    } catch (error) {
      console.error("Error processing payment:", error);
      Swal.fire({
        title: "Error!",
        text: error.message || "An error occurred",
        icon: "error",
        showConfirmButton: false,
        timer: 5000,
      });
    }
  };

  return (
    <div
      className="flex flex-row items-center gap-5 bg-cover bg-no-repeat bg-center pt-10 h-auto lg:h-[505px] w-full md:px-16 py-5"
      style={{
        backgroundImage: `url(${PaymentBg})`,
      }}
    >
      <div className="flex flex-col w-full md:w-1/2 max-sm:px-5">
        <h1 className="font-bold text-white text-3xl md:text-[55px] mb-2">
          Making a payment?
        </h1>
        <p className="md:text-[22px] text-white">
          Easily pay for your transactions and sessions with{" "}
          <span className="max-sm:hidden">
            <br />
          </span>
          ProSynergy (this is placeholder text only).
        </p>

        <form onSubmit={(e) => handleSubmit(e, onSubmit)}>
          <div className="flex flex-col gap-5 mt-8 md:w-4/5">
            <div>
              <label
                htmlFor="tranno"
                className="block md:text-[19px] font-medium text-white"
              >
                Enter Transaction ID Number
              </label>
              <input
                type="text"
                id="tranno"
                name="tranno"
                value={values.tranno}
                onChange={handleChange}
                placeholder="REMS-2025-10-0001"
                className="form-input mt-1 block w-full border-gray-300 rounded-lg shadow-sm focus:ring-green-800 focus:border-green-800"
              />
              {errors.tranno && <p className="text-red-600">{errors.tranno}</p>}
              {isVerifying && (
                <p className="text-yellow-500">Verifying transaction ID...</p>
              )}
              {invoice && (
                <p className="text-green-500">Transaction ID verified!</p>
              )}
            </div>
            <button
              type="submit"
              className="text-white bg-[var(--customRed)] hover:bg-red-800 focus:ring-2 focus:outline-none focus:ring-red-300 font-medium rounded-full px-5 py-2.5 text-center"
              disabled={isSubmitting || isVerifying || !invoice}
            >
              {isSubmitting ? "Processing..." : "Pay for Transaction"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Payment;
